import React from "react";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  formConfig,
  DynamicField,
} from "./../../../index";

interface QuoteDetailsFormProps {
  formData: Record<string, string | number | boolean | File | Date>;
  filesMap: Record<string, File[]>;
  setFilesMap: React.Dispatch<React.SetStateAction<Record<string, File[]>>>;
  handleChange: (key: string, value: string | number | boolean | File | Date) => void;
  onSubmit?: () => void;
  submitting?: boolean;
}

export const QuoteDetailsForm = ({ formData, filesMap, setFilesMap, handleChange, onSubmit, submitting }: QuoteDetailsFormProps) => (
  <div className="lg:col-span-2">
    <Card>
      <CardHeader>
        <CardTitle>Quote Details</CardTitle>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {formConfig.map((field) => (
            <div
              key={field.key}
              className = {
                field.type === "textarea" ||
                field.type === "uploader" ||
                field.type === "calendar"
                ? "col-span-2"
                : ""
              }
            >
              <DynamicField
                field={{
                  ...field,
                  name: field.key,
                }}
                value={formData[field.key]}
                onChange={(val) => handleChange(field.key, val)}
                filesMap={filesMap}
                setFilesMap={setFilesMap}
              />
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  </div>
);